import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import {IoCheckmarkCircle, IoAlertCircle, IoDocument, IoCloudUpload, IoClose} from 'react-icons/io5';
import * as yup from 'yup';
import docIcon from './document.png';
import {MdDeleteForever} from "react-icons/md";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CaseFilesStatus from "../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import CaseStatus from "../../enums/CaseStatus";
import {Tooltip} from "@mui/material";
import LoaderCustom from "../ConfirmationModal/LoaderCustom";
import CaseFilesInternal from "../../enums/CaseFilesInternal";


const UploadMissingFiles = ({
                                caseFiles,
                                permitTypeId,
                                onClose,
                                onFileAdded,
                                onCaseStatusChange,
                                showUploadMissingFiles
                            }) => {
    const [fileTypes, setFileTypes] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [fileErrors, setFileErrors] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const fileInputRefs = useRef({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const params = new URLSearchParams(window.location.search);
    const caseType = parseInt(params.get('id'), 10);
    const [formattedFileNames, setFormattedFileNames] = useState({});
    const [isNoButtonDisabled, setIsNoButtonDisabled] = useState(false);
    const [modalText, setModalText] = useState("დარწმუნებული ხართ?");
    const [isAccelerationEnabled, setIsAccelerationEnabled] = useState(false);
    const [allRequiredUploaded, setAllRequiredUploaded] = useState(false);
    const [isLoadingFileTypes, setIsLoadingFileTypes] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const uploadedFileTypeIds = new Set(caseFiles.map(file => file.fileTypeId));

    const handleCloseDialog = () => {
        onClose();
        onFileAdded()
    };


    useEffect(() => {
        if (showUploadMissingFiles) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showUploadMissingFiles]);


    const checkAllRequiredUploaded = () => {
        const allUploaded = fileTypes.every(fileType => {
            return !fileType.required || (fileType.required && uploadedFiles[fileType.id]);
        });
        setAllRequiredUploaded(allUploaded);
    };
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                handleCloseDialog();
            }
        };

        window.addEventListener('keydown', handleEscape);

        return () => window.removeEventListener('keydown', handleEscape);
    }, [onClose]);


    const fetchCaseDetails = async () => {
        try {
            const caseId = parseInt(params.get('id'), 10);
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCaseByIdByuser?Id=${caseId}`);
            if (response.data.success) {
                setIsAccelerationEnabled(response.data.data.acceleration);
            } else {
            }
        } catch (error) {
        }
    };
    useEffect(() => {
        void fetchCaseDetails();
    }, []);

    useEffect(() => {
        if (isAccelerationEnabled !== undefined) {
            void fetchData();
        }
    }, [isAccelerationEnabled]);


    const fetchData = async () => {
        setIsLoadingFileTypes(true)
        await fetchCaseDetails()
        try {
            const responseFileTypes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllFileTypes`);
            if (responseFileTypes.data.success) {
                let allFileTypes = responseFileTypes.data.data.filter(type => type.caseId === permitTypeId);

                allFileTypes = allFileTypes.sort((a, b) => a.sort - b.sort);
                const uploadedFileTypeIds = new Set(caseFiles.map(file => file.fileTypeId));

                const newUploadProgress = {};
                const newUploadedFiles = {};
                const newFileErrors = {};
                const newFileInputRefs = {};

                allFileTypes.forEach(fileType => {
                    const isUploaded = uploadedFileTypeIds.has(fileType.id);
                    newFileInputRefs[fileType.id] = React.createRef();
                    newUploadProgress[fileType.id] = isUploaded ? 100 : 0;  // Set progress to 100 if already uploaded
                    newUploadedFiles[fileType.id] = isUploaded ? {file: null, resultId: undefined} : null; // Placeholder for actual file info
                    newFileErrors[fileType.id] = null;
                });

                setFileTypes(allFileTypes);
                setUploadProgress(newUploadProgress);
                setUploadedFiles(newUploadedFiles);
                setFileErrors(newFileErrors);
                fileInputRefs.current = newFileInputRefs;
                setIsLoadingFileTypes(false)
            }
        } catch (error) {
        }
    };


    const handleBoxClick = (fileTypeId) => {
        fileInputRefs.current[fileTypeId].current.click();
    };


    const handleFileChange = (fileType, event) => {
        const file = event.target.files[0];
        if (file) {
            let formattedName = file.name;
            if (formattedName.length > 30) {
                const fileExtension = formattedName.substring(formattedName.lastIndexOf('.'));
                formattedName = formattedName.substring(0, 27) + '...' + fileExtension;
            }

            setFormattedFileNames(prevState => ({...prevState, [fileType.id]: formattedName}));
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
            const maxSizeBytes = 5000 * 1048576; // 1 MB = 1048576 bytes

            if (file.size > maxSizeBytes) {
                setFileErrors(prevState => ({
                    ...prevState,
                    [fileType.id]: `ფაილის ზომა აღემატება 5000MB.`
                }));
            } else if (!fileType.extension.includes(fileExtension)) {
                setFileErrors(prevState => ({...prevState, [fileType.id]: "არასწორი ფორმატი!"}));
            } else {
                setFileErrors(prevState => ({...prevState, [fileType.id]: null}));
                setUploadedFiles(prevState => ({...prevState, [fileType.id]: file}));
                uploadFile(fileType, file);
            }

            // Reset the input value
            event.target.value = null;
        }
    };

    const uploadFile = async (fileType, file) => {
        const fileBase64 = await toBase64(file);
        const fileData = {
            caseID: caseType,
            name: fileType.title,
            ext: file.name.split('.').pop(),
            file: fileBase64,
            mainInfo: "",
            additionalInfo: "",
            shared: true,
            blank: false,
            documentType: 0,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.Sent,
            decline: CaseFileDeclined.No,
            fileTypeId: fileType.id,
            declinedInternalStatus: 0,
            registeryDocumentType: fileType.registeryDocumentType,
            inActiveIsInspectionSertificate: fileType.isinspectionSertificate
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData, {
                onUploadProgress: progressEvent => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(prevState => ({...prevState, [fileType.id]: percentCompleted}));
                }
            });

            if (response.data.success && response.data.resultId !== undefined) {
                setUploadedFiles(prevState => ({
                    ...prevState,
                    [fileType.id]: {
                        file: file,
                        resultId: response.data.resultId
                    }
                }));
                // Final progress update if needed
                setUploadProgress(prevState => ({...prevState, [fileType.id]: 100}));
            }
        } catch (error) {
            setAlertMessage("Upload failed: " + error.message);
            setAlertType("error");
            setShowAlert(true);
            setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
        }
    };

    const handleViewDocument = (fileType) => {
        const file = uploadedFiles[fileType.id];
        if (file) {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
            URL.revokeObjectURL(fileURL);
        }
    };

    const validateUploads = async () => {
        let schema = yup.object().shape({});
        fileTypes.forEach(fileType => {
            if (fileType.required) {
                schema = schema.shape({
                    [fileType.id]: yup.mixed().required(`დოკუმენტი სავალდებულოა!`)
                });
            }
        });

        try {
            await schema.validate(uploadedFiles, {abortEarly: false});
            return true;
        } catch (err) {
            err.inner.forEach(error => {
                setFileErrors(prev => ({...prev, [error.path]: error.message}));
            });
            return false;
        }
    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // Extracting the base64 part of the data URL
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = error => reject(error);
    });

    const sendNotification = async (caseId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CreateCaseNotificationforHeadOfAgency`, {
                caseId: caseId,
                caseStatus: CaseStatus.Sent.id,
                action: 1
            });

        } catch (error) {
        }
    };

    const performUpload = async () => {
        setIsUploading(true);
        setIsNoButtonDisabled(true);
        try {
            setIsUploading(false);
            setIsNoButtonDisabled(false);
            setModalText("დარწმუნებული ხართ?");

            const urlParams = new URLSearchParams(window.location.search);
            const caseId = urlParams.get('id');
            if (caseId) {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseStatusByUser`, {
                    caseId: parseInt(caseId, 10),
                    caseStatus: CaseStatus.Sent.id,
                    finished: false
                });

                await sendNotification(parseInt(caseId, 10))
            }

            onCaseStatusChange()
            onFileAdded();

            setAlertMessage("Upload and Case Status Update successful!");
            setAlertType("success");
        } catch (error) {
            setAlertMessage("Error: " + error.message);
            setAlertType("error");
        } finally {
            setIsUploading(false);
            setIsModalOpen(false);

            onClose();
        }
    };


    const handleDeleteFile = async (fileType) => {
        const fileDetails = uploadedFiles[fileType.id];
        if (fileDetails && fileDetails.resultId) {
            try {
                const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFileByUser`, {
                    caseFileId: fileDetails.resultId
                });

                if (response.data.success) {
                    setUploadedFiles(prevState => ({...prevState, [fileType.id]: null}));
                    setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
                    setFileErrors(prevState => ({...prevState, [fileType.id]: null}));
                    setFormattedFileNames(prevState => ({...prevState, [fileType.id]: ''}));
                    checkAllRequiredUploaded();

                    if (fileInputRefs.current[fileType.id]) {
                        fileInputRefs.current[fileType.id].current.value = '';
                    }
                }
            } catch (error) {

            }
        } else {
            try {
                const prevUploadedFileToDelete = caseFiles.find(file => file.fileTypeId === fileType.id)
                const prevUploadedFileToDeleteId = prevUploadedFileToDelete.id || null
                const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFileByUser`, {
                    caseFileId: prevUploadedFileToDeleteId.toString()
                });

                if (response.data.success) {
                    setUploadedFiles(prevState => ({...prevState, [fileType.id]: null}));
                    setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
                    setFileErrors(prevState => ({...prevState, [fileType.id]: null}));
                    setFormattedFileNames(prevState => ({...prevState, [fileType.id]: ''}));
                    onFileAdded();
                    await fetchData();
                    checkAllRequiredUploaded();

                }
            } catch (error) {

            }
        }
    };

    useEffect(() => {
        checkAllRequiredUploaded();
    }, [fileTypes, uploadedFiles]);
    const handleUploadFiles = async () => {
        if (!await validateUploads()) {
            return;
        }
        setIsModalOpen(true);
    };


    return (
        <div className={"upload-single-popup-missing-files"}>
            <div className="file-upload-page-missing-files">

                <div className="upload-heading">

                    <div className={"doc-page-title"}>დანართები</div>
                    <div>
                        <IoClose onClick={handleCloseDialog} className="reupload-close-btn" size="24px"/>
                        <div className="top-right-tooltip">
                            <Tooltip
                                title={(isUploading || !allRequiredUploaded) ? "განაცხადის რეგისტრაციისთვის ატვირთეთ ყველა სავალდებულო დოკუმენტი!" : ""}>
                                <button onClick={handleUploadFiles} disabled={isUploading || !allRequiredUploaded}
                                        className="upload-button">
                                    <IoCloudUpload size="24px" className={"upload-icon"}/>
                                    {isUploading ? 'განაცხადი იგზავნება...' : 'განაცხადის გაგზავნა'}
                                </button>
                            </Tooltip>
                        </div>

                    </div>
                </div>
                <div>
                </div>

                {(isLoadingFileTypes && fileTypes.length === 0) || isLoading  ? (
                    <div className="file-upload-container">
                        <LoaderCustom/>
                    </div>
                ) : (
                    <div className="file-upload-container">
                        {fileTypes.map(fileType => (
                            <div>
                                <div key={fileType.id}
                                     className={`file-box ${uploadProgress[fileType.id] === 100 || uploadedFileTypeIds.has(fileType.id) ? 'upload-complete' : ''}`}
                                     onClick={() => handleBoxClick(fileType.id)}>
                                    <img src={docIcon} alt="Document" className="document-icon"/>
                                    <div className="file-content">
                                        <div className="file-top">
                                            <div>
                                                <h4 className={"documnet-title"}>{fileType.title}</h4>
                                                <div className={"documnet-title"}>გაფართოება: {fileType.extension}</div>
                                                <div className={"documnet-title"}>მაქსიმალური
                                                    ზომა: 5000MB.
                                                </div>
                                                <div
                                                    className={"documnet-title"}>{formattedFileNames[fileType.id]}</div>
                                            </div>

                                            {fileType.required && uploadProgress[fileType.id] !== 100 && !uploadedFileTypeIds.has(fileType.id) && (
                                                <div className="icon-container">
                                                    <IoAlertCircle color="red" fontSize={"24px"}/>
                                                </div>
                                            )}
                                            {(uploadProgress[fileType.id] === 100 || uploadedFileTypeIds.has(fileType.id)) && (
                                                <div className="icon-container">
                                                    <IoCheckmarkCircle size="24px" color="green"/>
                                                </div>
                                            )}
                                        </div>
                                        {fileErrors[fileType.id] &&
                                            <div className="error-message-doc">{fileErrors[fileType.id]}</div>}

                                        {!uploadedFileTypeIds.has(fileType.id) && (
                                            <input
                                                type="file"
                                                ref={fileInputRefs.current[fileType.id]}
                                                style={{display: 'none'}}
                                                accept={`${fileType.extension}`}
                                                onChange={(e) => handleFileChange(fileType, e)}
                                            />
                                        )}
                                    </div>
                                    {uploadProgress[fileType.id] > 0 && uploadProgress[fileType.id] < 100 && (
                                        <div className="progress-bar-container">
                                            <div
                                                className="progress-bar-fill"
                                                style={{ width: `${uploadProgress[fileType.id]}%` }}
                                            ></div>
                                            <span className="progress-bar-text">
            {uploadProgress[fileType.id]}%
        </span>
                                        </div>
                                    )}


                                </div>
                                <div>
                                    {(uploadProgress[fileType.id] === 100 || uploadedFileTypeIds.has(fileType.id)) && (
                                        <div className="documnet-actions-contaioner">
                                            <button className={"view-doc-button"}
                                                    onClick={() => handleViewDocument(fileType)}>
                                                <IoDocument/> ნახვა
                                            </button>
                                            <button className={"view-del-button"}
                                                    onClick={() => handleDeleteFile(fileType)}>
                                                <MdDeleteForever/> წაშლა
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>


                        ))}

                    </div>
                )}

            </div>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={performUpload}
                isNoButtonDisabled={isNoButtonDisabled}
                modalText={modalText}
            />
            {showAlert && (
                <CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setShowAlert(false)}
                />
            )}
        </div>
    );
};

export default UploadMissingFiles;
